export default "__VITE_ASSET__5a57901b__"